export const environmentBase = {
  initialized: false,
  production: false,
  appFrontend:{
    tenantId: '',
    clientId: '',
    authority: 'https://login.microsoftonline.com/_TENANT_ID_',
    redirect: {
      url: '',
      scopes: ['openid', 'profile','User.Read']
    },
    postLogoutRedirect:{
      url: '',
    },
    modules:{
      administracion:{
        modules:{
          clientes:{
            active:true
          },
          contactos:{
            active:true
          }
        },
        active:true
      },
      hosting:{
        modules:{
          cuentas:{
            active:true
          }
        },
        active:true
      },
      dominios:{
        modules:{
          contratados_internacional:{
            active:true
          }
        },
        active:true
      },
      soporte:{
        modules:{
          callcenter:{
            active:true
          },
          tickets:{
            active:true
          }
        },
        active:true
      },
    } 
  },
  appBackend:{
    clientId:'',
    accessScope:'api://_AUTH_API_CLIENT_ID_/access_as_user',
    scopes: ['openid', 'profile', 'email'],
    apiUrlBase:'',
  },
  entraId:{
    endpoint:'https://graph.microsoft.com/v1.0/me',
    scopes:['User.Read']
  },
  mode:'base'
};